export const successCreateMessage = "အသစ်ဖန်တီးခြင်း အောင်မြင်ပါသည်။";
export const successEditMessage = "ပြင်ဆင်ခြင်း အောင်မြင်ပါသည်။";
export const successDeleteMessage = "ဖျက်ခြင်း အောင်မြင်ပါသည်။";

export const serverErrorMessage = "Something was wrong!";

